/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRegistrationSitesResult } from '../../models/get-registration-sites-result';

export interface GetSites$Params {
  SearchPattern?: string;
  Latitude?: number;
  Longitude?: number;
}

export function getSites(
  http: HttpClient,
  rootUrl: string,
  params?: GetSites$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetRegistrationSitesResult>> {
  const rb = new RequestBuilder(rootUrl, getSites.PATH, 'get');
  if (params) {
    rb.query('SearchPattern', params.SearchPattern, {});
    rb.query('Latitude', params.Latitude, {});
    rb.query('Longitude', params.Longitude, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRegistrationSitesResult>;
    }),
  );
}

getSites.PATH = '/Registration/sites';
